'use strict';

var React = require('react');
var Typography = require('./Typography-fd6f932a.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Emphasis({ variation, children }) {
    const variationMap = {
        bold: { element: "b", fontWeight: "bold" },
        italic: { element: "em", emphasisType: "italic" },
        highlight: { element: "strong", emphasisType: "highlight" },
    };
    return React__default["default"].createElement(Typography.Typography, Object.assign({}, variationMap[variation]), children);
}

exports.Emphasis = Emphasis;
